import React from 'react';
import BankAccountDetails from './BankAccountDetails';
import OutFlowAndInflow from './OutFlowAndInFlow/OutFlowAndInflow';
import BalanceOverview from '../BalanceOverview/BalanceOverview';
import AvgBalanceChart from '../MonthlyAvgBalance/AvgBalanceChart';
import DepositsWithdrawals from '../Deposits&Withdrawals/DepositsWithdrawals';

const Overview = ({ url }) => {
  const scoreCards = [
    {
      key: 'Quality Score',
      name: 'Quality Score'
    },
    {
      key: 'Volatility Score',
      name: 'Volatility Score'
    },
    {
      key: 'Total Transaction',
      name: 'Total Transaction'
    },
    {
      key: 'Monthly avg balance',
      name: 'Monthly avg balance'
    }
  ];

  return (
    <div className="w-full">
      <div className="w-full flex bg-white  py-4 mt-5 overflow-auto hide-scroll-bar">
        {scoreCards.map((each, index) => (
          <div className="flex w-full" style={{ minWidth: '180px' }}>
            <div className="py-3 px-5 w-full" key={index}>
              <div className="table mx-auto">
                <p className="text-black-500 text-xs ">{each.name}</p>
                <p className="text-right font-bold text-sm">---</p>
              </div>
            </div>
            <span
              style={{
                width: '1px',
                height: 'auto',
                backgroundColor: '#dee0f0'
              }}
            />
          </div>
        ))}
      </div>
      <div className="w-full md:flex gap-2 mt-4">
        <div className="w-full bg-white">
          <BankAccountDetails url={url} />
        </div>
        <div className="w-full bg-white">
          <OutFlowAndInflow />
        </div>
      </div>
      <div className="w-full md:flex gap-2 mt-4">
        <div className="md:w-6/12 bg-white">
          <BalanceOverview />
        </div>
        <div className="md:w-6/12 bg-white">
          <AvgBalanceChart />
        </div>
      </div>
      <div className="w-full md:flex gap-2 mt-4">
        <div className="md:w-6/12 bg-white">
          <DepositsWithdrawals />
        </div>
        <div className="md:w-6/12"></div>
      </div>
    </div>
  );
};

export default Overview;
